<template>
  <v-card id="create">
    <v-speed-dial
      v-model="fab"
      bottom
      right
      fixed
      fab
      direction="top"
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab small>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-format-list-bulleted</v-icon>
        </v-btn>
      </template>

      <v-btn fab dark small color="green">
        <v-icon>mdi-filter</v-icon>
      </v-btn>
      <v-btn fab dark small color="red" @click="toTop">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
    </v-speed-dial>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    fab: false,
  }),
  methods: {
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>
